document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search)
  const variantId = params.get('variant') || Object.keys(window.variantMetafields)[0]
  if (variantId && window.variantMetafields[variantId]) {
    updateUI(window.variantMetafields[variantId])
  }
})

document.addEventListener('variant:update', (e) => {
  const { resource, _sourceId, _data } = e.detail
  const metafields = window.variantMetafields[resource.id]
  if (metafields) updateUI(metafields)
})

function updateUI(metafields) {
  const productHeight = metafields['product-height'].value
  const productWidth = metafields['product-width'].value
  const imageHeight = metafields['image-height'].value
  const imageWidth = metafields['image-width'].value
  const text = `Product: ${productHeight} x ${productWidth} cm. Image: ${imageHeight} x ${imageWidth} cm.`
  document.querySelector('[data-fieldset-index="1"] legend').textContent = text
}
